
import { useToast } from '@/hooks/use-toast';
import { useTranslation } from 'react-i18next';
import { ServiceFormData } from './ServiceFormState';

export const useServiceValidation = () => {
  const { toast } = useToast();
  const { t } = useTranslation('dashboard');

  const validateForm = (formData: ServiceFormData, selectedFormats: Record<string, boolean>) => {
    if (!formData.service_name) {
      toast({
        variant: "destructive",
        title: t('servicesManagement.form.serviceNameRequired'),
        description: t('servicesManagement.form.serviceNameRequiredDescription')
      });
      return false;
    }

    const priceNum = Number(formData.price);
    const isPriceValid = formData.is_free_session
      ? !isNaN(priceNum) && priceNum >= 0
      : !isNaN(priceNum) && priceNum > 0;

    if (!isPriceValid) {
      toast({
        variant: "destructive",
        title: t('servicesManagement.form.validPriceRequired'),
        description: t('servicesManagement.form.validPriceRequiredDescription')
      });
      return false;
    }

    const formats = Object.entries(selectedFormats)
      .filter(([_, selected]) => selected)
      .map(([format]) => format);

    if (formats.length === 0) {
      toast({
        variant: "destructive",
        title: t('servicesManagement.form.sessionFormatRequired'),
        description: t('servicesManagement.form.sessionFormatRequiredDescription')
      });
      return false;
    }

    return true;
  };

  return { validateForm };
};
